import { makeStyles } from '@material-ui/styles';

export default makeStyles(
    {
        containerBotones: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '40px',
            marginBottom: '20px',
        },

        btnCancelar: {
            padding: '10px 55px',
            marginRight: '8px',
        },

        btnExito: {
            marginLeft: '8px',
        },

        containerBars: {
            maxHeight: '500px',
            minWidth: '400px',
            marginBottom: '20px',
            padding: '15px',
        },
    },
    { index: 1 }
);
